import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendOTP } from "../firebase"; // ✅ use centralized helper

export default function OTPLogin() {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ Smart redirect target (default: /home)
  const redirectAfterLogin =
    sessionStorage.getItem("redirectAfterLogin") || "/home";

  // ✅ Send OTP (logic unchanged, implementation fixed)
  const sendOTPHandler = async () => {
    if (!phone.match(/^\d{10}$/)) {
      alert("Please enter a valid 10-digit Indian number");
      return;
    }

    const fullPhone = `+91${phone}`;
    setLoading(true);

    try {
      const confirmation = await sendOTP(fullPhone);
      setConfirmationResult(confirmation);
      alert("✅ OTP sent to " + fullPhone);
    } catch (error) {
      console.error(error);

      if (error.code === "auth/invalid-app-credential") {
        alert(
          "❌ Invalid app credentials.\nPlease ensure your domain is added in Firebase Authorized Domains."
        );
      } else if (error.code === "auth/missing-recaptcha-token") {
        alert("⚠️ reCAPTCHA failed. Please refresh and try again.");
      } else {
        alert("❌ " + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // ✅ Verify OTP (unchanged)
  const verifyOTP = async () => {
    if (!otp) return alert("Enter the OTP received");

    setLoading(true);
    try {
      const result = await confirmationResult.confirm(otp);
      setUser(result.user);
      alert("🎉 Login successful!");

      setTimeout(() => {
        navigate(redirectAfterLogin, { replace: true });
        sessionStorage.removeItem("redirectAfterLogin");
      }, 1000);
    } catch (error) {
      console.error(error);
      alert("❌ Invalid OTP, please try again");
    } finally {
      setLoading(false);
    }
  };

  // ✅ After Login UI (unchanged)
  if (user) {
    return (
      <div style={styles.container}>
        <img
          src="/eyal-logo.png"
          alt="Eyal App"
          style={{ width: "80px", marginBottom: "20px" }}
        />
        <h2 style={styles.title}>Welcome!</h2>
        <p style={styles.subtitle}>{user.phoneNumber}</p>
        <p style={styles.note}>You are now logged in ✅</p>
      </div>
    );
  }

  // ✅ Default UI (unchanged)
  return (
    <div style={styles.container}>
      <img
        src="/eyal-logo.png"
        alt="Eyal App"
        style={{ width: "80px", marginBottom: "20px" }}
      />
      <h2 style={styles.title}>Login with OTP</h2>

      {!confirmationResult ? (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span style={{ marginRight: "8px", fontWeight: "600" }}>+91</span>
            <input
              type="tel"
              placeholder="Enter 10-digit number"
              maxLength="10"
              value={phone}
              onChange={(e) =>
                setPhone(e.target.value.replace(/\D/g, ""))
              }
              style={{ ...styles.input, width: "80%" }}
            />
          </div>

          <button
            onClick={sendOTPHandler}
            style={styles.button}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send OTP"}
          </button>
        </>
      ) : (
        <>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            style={styles.input}
          />
          <button
            onClick={verifyOTP}
            style={styles.button}
            disabled={loading}
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </button>
        </>
      )}

      {/* 🔒 reCAPTCHA container (must exist) */}
      <div id="recaptcha-container"></div>

      <p style={styles.hint}>
        OTP will be sent via SMS to your registered mobile number.
      </p>
    </div>
  );
}

// 🎨 Modern clean styling (UNCHANGED)
const styles = {
  container: {
    textAlign: "center",
    padding: "40px 20px",
    fontFamily: "system-ui, sans-serif",
    background: "#fff",
    borderRadius: "20px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    width: "90%",
    maxWidth: "380px",
    margin: "auto",
    marginTop: "40px",
  },
  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#007bff",
    marginBottom: "15px",
  },
  subtitle: {
    fontSize: "16px",
    color: "#333",
    marginBottom: "8px",
  },
  input: {
    width: "100%",
    maxWidth: "320px",
    padding: "12px 14px",
    borderRadius: "10px",
    border: "1px solid #ddd",
    marginTop: "10px",
    fontSize: "16px",
    outline: "none",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  },
  button: {
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    marginTop: "15px",
    transition: "0.2s ease",
  },
  note: {
    marginTop: "15px",
    color: "#666",
    fontSize: "14px",
  },
  hint: {
    marginTop: "20px",
    fontSize: "13px",
    color: "#888",
  },
};
